var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import PropTypes from "prop-types";
import { BaseBox } from '../Element';
var Svg = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var IconBase = function (_a) {
    var _b = _a.style, style = _b === void 0 ? {} : _b, props = __rest(_a, ["style"]);
    return (React.createElement(Svg, __assign({ as: 'svg', "aria-hidden": 'true', focusable: 'false', role: 'img', fill: 'currentColor', preserveAspectRatio: 'xMidYMid meet' }, props, { style: __assign({}, style) })));
};
IconBase.prototype = {
    style: PropTypes.object,
};
export default IconBase;
var templateObject_1;
